<template>
  <v-app class="application">
    <Layout>
      <router-view />
    </Layout>
  </v-app>
</template>

<script>
  import Layout from '@/components/layout/Main.vue'

  export default {
    name: 'App',

    components: {
      Layout
    }
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');

* {
  font-family: 'Lato', sans-serif;
}

body {
  background-color: $applicationBackground;
}

.application {
  background: $applicationBackground !important;
}

</style>
